<template>
  <aside :class="`app-sidebar ${openSidebar ? 'app-sidebar--open' : ''}`">
    <feeds-list :translation-play="translationPlay"/>
    <template v-if="onRoute === 'threadId'">
      <statistic />
      <post-chart
        :open-sidebar="openSidebar"
        :parentDataForChart="dataForChart"
        v-if="Object.keys(dataForChart).length"
        :parentPending="reqPending"
      />
      <tonal-chart
        :open-sidebar="openSidebar"
        :parentDataForChart="dataForChart"
        v-if="Object.keys(dataForChart).length"
        :parentPending="reqPending"
      />
      <sidebar-controls @onSideBarToggle="handleSideBarToggle"/>
    </template>
    <template v-else>
      <div class="sidebar-button-wrap">
        <back-button />
        <print-button @onClick="switchPrintMethod"/>
      </div>
    </template>
  </aside>
</template>

<script>
// components
import FeedsList from "./components/FeedsList.vue";
import TonalChart from "./components/tonalChart/TonalChart.vue";
import PostChart from "./components/postChart/PostChart.vue";
import Statistic from "./components/statistic/Statistic.vue";
import SidebarControls from "./components/sidebarControls/SidebarControls.vue";
import BackButton from './components/BackButton.vue';
import PrintButton from './components/PrintButton.vue';
import moment from 'moment';
// mixins
import printReportMixin from '../../../mixins/printReport';
import printPictureMixin from '../../../mixins/printPicture';

// api
import { getTrustDaylyApi } from '../../../api/posts';

export default {
  name: "AppSidebar",
  props: {
    translationPlay: {
      type: Boolean,
      required: true
    },
    openSidebar: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      feedId: 0,
      onRoute: '',
      dataForChart: {},
      reqPending: false,
      errorLoading: false,
      methods: {
        report: 'printReportDocument',
        picture: 'printPictureDocument'
      }
    }
  },
  methods: {
    getDataForChart () {
      this.reqPending = true;

      const params = {
        thread_id: this.$route.params.id,
        from: moment().subtract(8,'d').format('YYYY-MM-DD') + '00:00:00',
        to: moment().format('YYYY-MM-DD') + '23:59:59',
      };

      getTrustDaylyApi(params)
        .then((resp) => {
          this.dataForChart = resp.data.total;
          this.reqPending = false;
        })
        .catch(() => {
          this.errorLoading = true;
        });
    },
    handleSideBarToggle() {
      this.$emit('onToggleSidebar');
    },
    switchPrintMethod() {
      if (this.onRoute) {
        this[this.methods[this.onRoute]]();
      }
    }
  },
  mounted() {
    this.onRoute = this.$route.name;
    this.getDataForChart();
  },
  watch: {
    $route(route) {
      this.onRoute = route.name;
    },
  },
  components: {
    FeedsList,
    TonalChart,
    PostChart,
    Statistic,
    SidebarControls,
    BackButton,
    PrintButton
  },
  mixins: [
    printReportMixin,
    printPictureMixin
  ],
};
</script>

<style>
.app-sidebar {
  position: relative;
  width: 288px;
  margin-right: 20px;
  background-color: #ffffff;
}

.sidebar-button-wrap {
  margin-top: 60px;
  position: relative;
  display: flex;
  justify-content: space-between
}

@media (max-width: 1040px) {
  .app-sidebar {
    display: none;
    height: calc(100vh);
  }

  .app-sidebar--open {
    display: block;
    position: absolute;
    top: 80px;
    left: 0;
    width: 760px;
    z-index: 3;
    padding: 0 20px 20px 10px;
    margin: 0;
    box-sizing: border-box;
  }
}

@media (max-width: 760px) {
  .app-sidebar {
    display: none;
  }

  .app-sidebar--open {
    display: block;
    position: absolute;
    top: 120px;
    left: 0;
    width: 100%;
    z-index: 3;
    padding: 0 5px;
    margin: 0;
    box-sizing: border-box;
  }
}
</style>
